var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 150,
    viewBox: "0 0 542 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.809 67.9485H211.983V86.0254L218.036 90.5126H234.65V101.987H229.305H209.794L198.396 90.6408V68.269L214.366 52.3716H233.169H235.358H254.29V34.3588L248.237 29.8716H199.298L172.768 56.2818V93.6536L199.298 120.064L205.351 124.551H240.703H251.263H258.798V72.4998L252.809 67.9485Z",
    fill: "#080B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.361 47.8844L338.774 34.3588L332.721 29.8716H272.32V45.7049V65.9613V68.1408V83.9741V120.064L278.373 124.551H296.468V88.4613H314.82L326.668 120.064L332.721 124.551H352.361L338.774 88.4613L352.361 74.9357V47.8844ZM296.468 65.9613V65.1921V57.6921V52.4357H326.668V61.4741L322.161 65.9613H306.32H296.468Z",
    fill: "#080B31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M439.357 52.3716V34.3588L433.304 29.8716H381.918H363.823V47.8844V65.9613V83.9741V101.987V115.513V120.064L369.876 124.551H439.357V106.538L433.304 101.987H387.971V88.4613H431.758V70.4485L425.705 65.9613H387.971V52.3716H439.357Z",
    fill: "#080B31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M536.011 29.8716H511.799L494.413 55.1921L480.118 34.3588L474.065 29.8716H449.917L480.89 74.9357L449.917 120.064L455.97 124.551H480.118L497.504 99.2306L511.799 120.064L517.852 124.551H542L511.091 79.487L542 34.3588L536.011 29.8716Z",
    fill: "#080B31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7872 115.192L93.7569 115.705V114.295L92.7266 114.808V113.397L91.6963 113.846V112.436L90.666 112.949V111.538L89.6357 111.987V110.577L88.6054 111.09V109.679L87.5751 110.192V108.718L86.5448 109.231V107.821L85.5146 108.333V106.859L84.4843 107.372V105.962L79.6547 108.269L79.0108 108.462L78.6245 107.372L77.9805 107.5L77.5942 106.41L76.9502 106.603L76.5639 105.513L75.9199 105.705L75.5336 104.551L74.8896 104.744L74.5033 103.654L73.8593 103.846L73.473 102.692L72.829 102.885L72.4427 101.795L71.7987 101.987L71.4124 100.897L65.6814 102.436L65.3594 101.41L64.7155 101.538L64.3291 100.449L63.6852 100.641L63.2988 99.5513L62.6549 99.6795L62.2685 98.5898L61.6246 98.7821L61.2382 97.6923L60.5943 97.8846L60.2079 96.7308L59.564 96.9231L59.1776 95.8333L58.5337 96.0256L58.1473 94.8718L57.5034 95.0641L57.117 93.9744L46.2345 96.9231L43.852 95.7692V59.6795L57.5678 53.0769L68.5147 56.0256L71.7987 46.2179L71.8631 46.1538L82.81 49.1026L86.0941 39.2949L95.8175 44.0385V14.7436L94.7872 14.2308V13.7821L93.7569 13.3333V12.8846L92.7266 12.4359V11.9872L91.6963 11.4744V11.0256L90.666 10.5769V10.1282L89.6357 9.61539V9.16667L88.6054 8.71795V8.26923L87.5751 7.75641V7.30769L86.5448 6.85897V6.41026L85.5146 5.89744V5.51282L84.4843 5V4.55128L74.6964 0L0 34.9359V104.872L1.0303 105.321V105.769L2.06059 106.282V106.667L3.09089 107.179V107.628L4.12118 108.077V108.526L5.15148 109.038V109.487L6.18178 109.936V110.385L7.21207 110.897V111.346L8.24237 111.795V112.244L9.27266 112.756V113.141L10.303 113.654V114.103L11.3333 114.551V115L86.0941 150L95.8175 145.385V116.154L94.7872 116.667V115.192Z",
    fill: "#080B31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.753 69.4233V68.4617H145.722V67.5643H144.692V66.6028H143.662V65.7053H142.632V64.7438H141.601V63.8463H140.571V62.9489H139.541V61.9874H138.51V61.0899H137.48V60.1284H136.45V59.231H83.5183L57.439 72.8848H60.2079L58.4693 73.7822L61.2382 73.8463L59.4996 74.7438H62.2685L60.5299 75.6412L63.2988 75.7053L61.5601 76.6028H64.3291L62.5904 77.5002H65.3594L63.6207 78.4617H66.3897L64.651 79.3592H67.42L65.6813 80.3207H68.4503L66.7116 81.2181H69.4805L67.7419 82.1156L70.5752 82.1797L68.7722 83.0771L110.435 83.2053V111.667L111.465 111.154V112.628L112.495 112.116V113.526L113.526 113.013V114.487L114.556 113.91V115.385L115.586 114.872V116.346L116.617 115.769V117.244L117.647 116.731V118.141L118.742 117.628V119.103L119.772 118.59V120L120.802 119.487V120.962L121.832 120.385V121.859L147.783 108.398V69.4233H146.753Z",
    fill: "#080B31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5183 59.231L57.439 72.8848L110.435 73.0771V111.667L136.45 98.2694V59.231H83.5183Z",
    fill: "url(#paint0_linear_187_183)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6964 110.641L71.4124 100.897L60.5299 103.782H60.4011L57.117 93.9744L46.2345 96.9231L32.4543 90.2564V49.4872L46.2345 42.8846L57.1814 45.8333L60.4011 36.0256L60.4655 35.9615L71.4768 38.9103L74.7608 29.1026L84.4843 33.8461V4.55128L74.6964 0L0 34.9359V104.872L74.6964 139.808L84.4843 135.256V105.962L74.6964 110.641Z",
    fill: "url(#paint1_linear_187_183)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M345.664 43.3972L332.077 29.8716H271.676V45.7049V65.9613V68.1408V83.9741V120.064H289.771V83.9741H312.437L326.024 120.064H345.664L332.142 83.9741L345.729 70.4485V43.3972H345.664ZM289.835 65.9613V60.7049V53.1408V47.8844H321.581L326.089 52.3716V61.41L321.581 65.8972H305.74H289.835V65.9613Z",
    fill: "url(#paint2_linear_187_183)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M433.304 47.8844V29.8716H381.918H363.823V47.8844V65.9613V83.9741V101.987V115.513V120.064H433.304V101.987H381.918V83.9741H425.705V65.9613H381.918V47.8844H433.304Z",
    fill: "url(#paint3_linear_187_183)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M536.011 29.8716H511.799L492.932 57.3716L474.065 29.8716H449.917L480.89 74.9357L449.917 120.064H474.065L492.932 92.5639L511.799 120.064H536.011L505.038 74.9357L536.011 29.8716Z",
    fill: "url(#paint4_linear_187_183)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M433.304 47.8844V29.8716H381.918H363.823V47.8844V65.9613V83.9741V101.987V115.513V120.064H433.304V101.987H381.918V83.9741H425.705V65.9613H381.918V47.8844H433.304Z",
    fill: "url(#paint5_linear_187_183)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M252.809 67.9485H211.983V86.0254H234.65V101.987H229.305H208.313L192.408 86.1536V63.7177L208.313 47.8844H227.116H229.305H248.237V29.8716H199.298L172.768 56.2818V93.6536L199.298 120.064H234.65H245.21H252.809",
    fill: "url(#paint6_linear_187_183)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_187_183",
    x1: 96.943,
    y1: 111.694,
    x2: 96.943,
    y2: 59.2168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_187_183",
    x1: 42.2318,
    y1: 139.79,
    x2: 42.2318,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_187_183",
    x1: 308.693,
    y1: 120.053,
    x2: 308.693,
    y2: 29.8472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_187_183",
    x1: 398.553,
    y1: 120.053,
    x2: 398.553,
    y2: 29.8472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_187_183",
    x1: 492.943,
    y1: 120.053,
    x2: 492.943,
    y2: 29.8472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_187_183",
    x1: 398.553,
    y1: 120.053,
    x2: 398.553,
    y2: 29.8472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_187_183",
    x1: 224,
    y1: 120,
    x2: 224,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07ECE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4325,
    stopColor: "#554AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F913E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.f23e9b86741b868057f8a98f60f7cd77.svg";
export { ForwardRef as ReactComponent };